import { render, staticRenderFns } from "./retained.vue?vue&type=template&id=001ed82f"
import script from "./retained.vue?vue&type=script&lang=js"
export * from "./retained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports